<template>
  <div class="index">
    <!--  小标题  -->
    <div class="title-wrapper large-title">
      <!--  <img src="../assets/image2025/miititle2025.png" /> -->
    </div>
    <!--  大标题  -->
    <div class="title-wrapper large-title2">
      <!-- <img src="../assets/image2025/maxtitle2025.png" /> -->
    </div>
    <!--    内容 -->
    <!-- <div class="content">
      <div class="info">
        <div>
          <h2>{{timeArr[0].title}}</h2>
          <h2 style="font-weight: 100; font-weight: bold;margin-bottom: 1.5rem;">{{timeArr[0].date}}</h2>
          <div class="text-wrapper">
            <p v-for="i in footerLeftArr" :key="i.id"><span class="text-wrapper-title">{{ i.title }}</span>{{ i.content }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="content-img">
      <!--  <img src="../assets/image2025/contentBg.png" alt=""> -->
    </div>
    <div class="right-box">
      <div class="box-content" v-for="j in doArr"  :key="j.id">
        <a :href="`${path}file/【资料包】2026年“书卷长流远·青春续华章”大学生读书演讲风采展示活动.rar`" download="2026年“书卷长流远·青春续华章”大学生读书演讲风采展示活动.rar" target="_blank">
          <img class="dot-image" :src=j.url   v-if="j.id !==2"/>
        </a>
        <!-- <div>
          <img class="dot-image" :src=j.url   v-if="j.id !==2"/>
        </div> -->
        <Tooltip placement="left-start" theme="light"  v-if="j.id ===2">
          <img class="dot-image" :src=j.url />
          <div slot="content">
            <div v-for="i in j.content" :key="i" v-html="i" v-show="j.id === 2"></div>
          </div>
        </Tooltip>
      </div>
    </div>
  </div>
</template>
<script>
// import { Divider } from 'view-design'
export default {
  name: 'Content',
  components: {
    // indexTitle
    // linearText
    // Divider
  },
  data () {
    return {
      path: process.env.BASE_URL,
      titleFirst: '第三届大学生读书演讲风采展示活动',
      dotArr: [
        '#ce8c06',
        '#dca23a',
        '#d8ab59',
        '#e9cd9f',
        '#f7ead5'
      ],
      doubleArr: [
        {
          id: 1,
          title: '活动对象',
          content: '全国各高校在校大学生',
          width: '45%',
          margin: '5%'
        },
        {
          id: 2,
          title: '活动简介',
          content: '根据活动主题自选书目阅读，将读书心得录制为演讲视频，在线参加大学生“悦读之星”读书演讲风采展示活动。',
          width: '50%'
        }
      ],
      connectTitle: '联系方式',
      connectArr: [
        {
          id: 1,
          title: '苏州大学图书馆',
          content: [
            '王老师：0512-65112714'
          ]
        },
        {
          id: 2,
          title: '读者之星网',
          content: [
            '陈老师：135-1299-4150',
            '李老师：138-2060-4300'
          ]
        },
        {
          id: 3,
          title: '活动交流QQ群',
          content: [
            '780962713'
          ]
        }
      ],
      footerLeftArr: [
        {
          id: 1,
          title: '主办单位：',
          content: '中国图书馆学会阅读推广委员会'
        },
        {
          id: 2,
          title: '承办单位：',
          content: '西南交通大学图书馆'
        },
        {
          id: 3,
          title: '支持单位：',
          content: '读者之星（天津）网络科技有限公司'
        },
        {
          id: 4,
          title: '组织单位：',
          content: '各高校图书馆'
        }
      ],
      footRightArr: [
        {
          id: 1,
          title: '公众号二维码',
          url: require('../assets/img/weixin.jpeg')
        },
        {
          id: 2,
          title: '活动QQ群',
          url: require('../assets/img/qrQQ.png')
        }
      ],
      timeArr: [
        {
          id: 1,
          title: '活动时间',
          line: '<div class="line"></div>',
          date: '2024年4月至9月'
        }
      ],
      doArr: [
        {
          id: 2,
          url: require('../assets/image2025/logo2.png'),
          cloud: 1,
          title: '联系</br>电话',
          content: [
            '<b>【活动咨询】</b>',
            '北京工商大学图书馆',
            '別老师：010-68986272',
            '<b>【作品上传及平台技术咨询】</b>',
            '读者之星（天津）网络科技有限公司',
            '李老师: 13512994150（微信同号）'
          ]
        },
        {
          id: 1,
          url: require('../assets/image2025/logo1.png'),
          cloud: 1,
          title: '文件</br>下载'
        }
        // {
        //   id: 3,
        //   url: require('../assets/image/tb3.png'),
        //   cloud: 1,
        //   title: '文献</br>资源'
        // }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
$font: 楷体;
$white: #fff;
$font-primary: #ffcd6d;
.index {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: auto;
  // position: relative;
  .title-wrapper {
    margin-bottom: -2.5%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
    .time-wrapper {
      position: absolute;
      z-index: 999;
      top: 5%;
      left: -10%;
      width: 25%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .gz2{
      width: 75%;
      height: 75%;
      position: absolute;
      z-index: 999;
      top: 80%;
      left: 390%;
      }
      .time-items {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        .time-item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .span-line {
          display: inline-block;
          width: 0.4rem;
          height: 6rem;
          background: $white;
          margin: 0 1.6rem;
        }
      }
    }
  }
  .large-title {
    margin-top: 3%; // 40 / 1920
    margin-left: 8%;
    width: 40vw;
    min-width: 850px;
  }
  .large-title2 {
    margin-top: 3.5%; // 40 / 1920
    margin-left: 8%;
    width: 35vw;
    min-width: 750px;
  }
  .content {
    position: relative;
    z-index: 999;
    width: 1300px;
    padding-bottom: 2%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    color: $white;
    font-size: 2rem;
    font-family: 'Noto Sans SC';
    margin-left: 8%;
    .info {
      h2 {
        font-size: 3rem;
        letter-spacing: 2px;
      }
      font-size: 2.5rem;
      width: 100%;
      margin-top: 12%;
      //color: #73181e;
      .text-wrapper {
        line-height: 1.5;
        text-shadow: 2px 3px 2px black;
        // font-weight: bold;
        // font-family: 'Noto Sans SC';
        .text-wrapper-title {
          color: $white;
          font-weight: 500;
          // font-size: 2.2rem;
        }
      }
    }
    ::v-deep .ivu-divider-horizontal {
      margin: 0.5rem 0;
    }
    ::v-deep .ivu-tooltip-rel {
      display: block;
    }
  }
  .content-img{
    position: absolute;
    bottom: 7%;
    left: 8%;
  }
  .right-box{
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    right: 10%;
    bottom: 10%;
    .box-content {
      margin-left: 1.5rem;
      &:first-child {
        margin-left: 0;
      }
    }
    .dot-image {
      width: 10rem;
    }
  }
}
</style>
<style>
.line {
  /*width: 30rem;*/
  width: 25rem;
  height: 1px;
  background: #efd725;
  /*margin-top: 1rem;*/
  /*margin-bottom: 1.5rem;*/
}
.text-p1 {
  text-align: center;
  font-size: 2.8rem;
  font-weight: bold;
  color: #ffc551;
}
.text-p2 {
  font-family: 楷体;
}
.text-title {
  width: 54vw;
  margin-top: 2%;
  /*margin-bottom: 1%;*/
}
.dot-first {
  display: inline-block;
  width: 1.6rem;
  height: 1.6rem;
  background: #ffcc51;
  border-radius: 50%;
  flex-shrink: 0;
  font-size: 1.4rem;
  font-weight: bold;
  color: #870201;
  text-align: center;
  line-height: 1.6rem;
}
a {
  color: #fff;
}
a:hover {
  color: #fff;
  text-decoration: underline;
}
a:link {
  color: #efd725;
}
a:visited {
  color: #efd725;
}
.linear {
  margin-top: 2rem;
}
@media screen and (max-width: 1600px){
  /* .index .content {
    padding-bottom: 2% !important;
  } */
}
@media screen and (max-width: 1300px){
  .linear {
    margin-top: 0;
  }
  .index .content {
    width: 1200px !important;
  }
}
@media screen and (min-height: 700px) and ( max-height: 1299px){
  .index .content {
    padding-bottom: 1% !important;
  }
  .index .content .info {
    margin-top: 13.5% !important;
  }
}
@media screen and (max-width: 1300px){
  .index .content .info {
    margin-top: 15.5% !important;
  }
  .large-title{
    margin-top: 5% !important;
  }
  .large-title2{
    margin-top: 5% !important;
  }
}
@media screen and (min-width: 1301px) and (max-width:1665px){
  .index .content .info {
    margin-top: 5.5% !important;
  }
  .large-title{
    margin-top: 4% !important;
  }
  .large-title2{
    margin-top: 4% !important;
  }
}
</style>
